import React from "react";
import { useState } from "react";
import { Dropzone, FileItem } from "@dropzone-ui/react";

const fileTypes = ["JPEG", "PNG", "GIF"];

export default function MediaUploader({ uploadUrl, onFileUploaded = f => f }) {
  const [files, setFiles] = useState([]);

  const updateFiles = (incomingFiles) => {
    setFiles(incomingFiles);
  };

  return (
    <div className="position-relative">
      <Dropzone
        minHeight="130px"
        maxHeight="200px"
        onChange={updateFiles}
        value={files}
        url={uploadUrl}
        footer={false}
        label="Drag and drop or click to upload"
        config={{
          headers: {
            "content-type": "multipart/form-data;",
            Accept: "application/json",
          },
        }}
        onUploadFinish={onFileUploaded}
        accept='image/webp,image/jpeg,image/jpg,image/png,image/bmp,image/gif,application/pdf,video/mp4'
        uploadOnDrop
      >
        {files.map((file, i) => (
          <FileItem key={i} {...file} preview />
        ))}
      </Dropzone>
      <div 
        className="position-absolute text-muted d-flex justify-content-center align-items-center w-100 h-100" 
        style={{ top: 0, left: 0, pointerEvents: 'none' }}
      >
        Drop files or click to upload
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./resources/js/components/Media/MediaUploader.js